import CompanyLogo from "@/components/common/CompanyLogo";
import { ArrowUpRightIcon } from "@/components/icons";
import { FactPill, SectionCard } from "@/components/posting/parts";
import type { Posting } from "@/lib/api/catalogue";
import { useClock } from "@/lib/clock";
import { actionProps } from "@/lib/controlAnalytics";
import { seenLine } from "@/lib/posting/page";
import { placeLine } from "@/lib/posting/places";
import { postingDetailPath } from "@/lib/routes";

/** The job, when it is a posting: who and where, whether it has closed, and the way to it. */
export default function PostingBox({ posting }: { posting: Posting }) {
    const { now, timeZone, locale } = useClock();
    const facts = [placeLine(posting), posting.employment_label]
        .filter(Boolean)
        .map((fact) => `${fact}.`)
        .join(" ");
    const path = postingDetailPath(posting.posting_id);
    return (
        <SectionCard>
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex min-w-0 items-center gap-3">
                    <CompanyLogo url={posting.logo_url ?? null} company={posting.company} />
                    <div className="flex min-w-0 flex-col items-start [overflow-wrap:anywhere]">
                        <span className="text-read font-semibold">{posting.company}</span>
                        {facts && <span className="text-ui text-fg-muted">{facts}</span>}
                        {posting.closed_at && (
                            <span className="mt-1">
                                <FactPill>
                                    {seenLine(posting, false, now, timeZone, locale)}
                                </FactPill>
                            </span>
                        )}
                    </div>
                </div>
                <a
                    {...actionProps("navigation_clicked", {
                        source: "ResumeCheck",
                        target: path,
                    })}
                    href={path}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap text-ui font-semibold text-brand-ink"
                >
                    View the posting
                    <ArrowUpRightIcon className="size-3.5" />
                </a>
            </div>
        </SectionCard>
    );
}
